import * as React from "react";
import { Grid } from "@mui/material";

import { MetricCard } from "./metricCard";
import { GaugeCard } from "./gaugeCard";

export type MonthlyProgressSummaryRowProps = {
  priorYearBonus: number;
  goal: number;
  percentToTarget: number;
  bonusGrowthPct: number;
  bonusGrowthAmount: number;
};

const currencyShort = (v: number): string => {
  if (v >= 1_000_000) {
    return `$${(v / 1_000_000).toFixed(1)} M`;
  }
  if (v >= 1_000) {
    return `$${(v / 1_000).toFixed(0)} k`;
  }
  return `$${v.toLocaleString("en-US")}`;
};

export const MonthlyProgressSummaryRow: React.FC<
  MonthlyProgressSummaryRowProps
> = ({
  priorYearBonus,
  goal,
  percentToTarget,
  bonusGrowthPct,
  bonusGrowthAmount,
}) => (
  <Grid container spacing={2} sx={{ mt: 2 }}>
    <Grid size={{ xs: 12, md: 2.4 }}>
      <MetricCard
        label="Prior Year Bonus"
        value={currencyShort(priorYearBonus)}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 2.4 }}>
      <MetricCard label="Goal" value={currencyShort(goal)} />
    </Grid>
    <Grid size={{ xs: 12, md: 2.4 }}>
      <GaugeCard label="% to Target" percentage={percentToTarget} />
    </Grid>
    <Grid size={{ xs: 12, md: 2.4 }}>
      <MetricCard
        label="Bonus Growth"
        value={`${bonusGrowthPct > 0 ? "+" : ""}${bonusGrowthPct.toFixed(0)}%`}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 2.4 }}>
      <MetricCard
        label="Bonus Growth"
        value={currencyShort(bonusGrowthAmount)}
      />
    </Grid>
  </Grid>
);
